<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="姓名/手机号/工号"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="头像"
        prop="people.avatar"
        show-overflow-tooltip
        width="80px"
      >
        <template #default="{ row }">
          <el-avatar shape="square" :size="40" fit="fill" :src="row.people.avatar || defaultAvatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="工号"
        prop="people.customId"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="姓名"
        prop="people.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="手机号"
        prop="people.tel"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="职务"
        prop="people.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="100px"
      >
        <template #default="{ row }">
          <el-button
            type="text"
            @click="handleDelete(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { getReceiverList, removeReceiver } from '@/api/stay'
import defaultAvatar from '@/assets/defaultAvatar.png'
import Edit from './edit.vue'
export default {
  name: 'Receiver',
  components: { Edit },
  data() {
    return {
      moment,
      defaultAvatar,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (to.path == '/stay/receiver') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleDelete(row) {
      this.$baseConfirm(`你确定要删除${row.people.name}吗`, null, async () => {
        await removeReceiver({ peopleId: row.peopleId })
        this.$baseMessage(
          `删除成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.queryData()
      })
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getReceiverList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.avatar {
   height: 64px;
   width: 128px;
   border-radius: 8px;
}
.mr-10 {
  margin-right: 10px;
}
</style>
